
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { setMenu } from "src/store/hamburgerMenu";
import burgurMenu from "../assets/img/burger-menu-svgrepo-com.svg";
import DateRange from "./layout/DatePicker";
import SearchBar from "./layout/SearchBar";
import BackButton from "./layout/BackButton";
import "../assets/css/material-dashboard.css";
import "../assets/css/material-dashboard.css.map";
import "../assets/css/nucleo-icons.css";
import "../assets/css/nucleo-svg.css";
import "../assets/css/material-dashboard.min.css";

const Header: React.FC<{
    searchValue: string;
    searchOnChange: React.ChangeEventHandler<HTMLInputElement>;
    clearValChange?: () => void;  // Function to clear search value
    startDate: Date;
    endDate: Date;
    startDateOnChange: (date: Date, event: React.SyntheticEvent<any, Event>) => void; // Adjust this line
    endDateOnChange: (date: Date, event: React.SyntheticEvent<any, Event>) => void; // Adjust this line
    // onSelectionChange: (selectedChildren: any[]) => void;
    showAllFilters: boolean;
    // clearSearchVal?: boolean;
    // goBack?: boolean;
    // formattedData: any[];
    // headers: any[];
    // exportPDF: () => void;
    // pageSize: number;
}> = ({
    searchValue, searchOnChange,
    clearValChange, startDate,
    endDate, startDateOnChange,
    endDateOnChange,
    showAllFilters
}) => {

    let currentEndpoint = window.location.pathname;

    const [title, setTitle] = useState("");
    const dispatch = useAppDispatch();
    const menuToggle = useAppSelector(state => state?.toggleMenu?.value);



    useEffect(() => {

        if (currentEndpoint.includes("/users")) {
            setTitle("Users")
        }
        else if (currentEndpoint.includes("/worker/category")) {
            setTitle("Worker Categories")
        }
        else if (currentEndpoint.includes("/worker/sub-categories")) {
            setTitle("Sub Categories and Specifications")
        }
        else if (currentEndpoint.includes("/workers")) {
            setTitle("Workers")
        }

        else if (currentEndpoint.includes("/doorstep/categories")) {
            setTitle("Doorstep Categories")
        }

        else if (currentEndpoint.includes("/doorstep/services")) {
            setTitle("Doorstep Services")
        }

        else if (currentEndpoint.includes("/professional/services")) {
            setTitle("Professional Doorstep Services")

        }
        else if (currentEndpoint.includes("/doorstep-orders")) {
            setTitle("Doorstep Orders")
        }
        else if (currentEndpoint.includes("/requirements")) {
            setTitle("Requirements")
        }
        else if (currentEndpoint.includes("/subscriptions/plans")) {
            setTitle("Subscription Plans")
        }
        else if (currentEndpoint.includes("/membership/plans")) {
            setTitle("Membership Plans")
        }
        else if (currentEndpoint.includes("/support")) {
            setTitle("Help & Supports")
        }
        else if (currentEndpoint.includes("/requeriment-values")) {
            setTitle("Requirement Values")
        }
        else if (currentEndpoint.includes("/feature-values")) {
            setTitle("Subscription Feature Values")
        }
        else if (currentEndpoint.includes("/membership/sales")) {
            setTitle("Membership Sales")
        }
        else if (currentEndpoint.includes("/subscription/sales")) {
            setTitle("Subscription Sales")
        }
        else if (currentEndpoint.includes("/transactions")) {
            setTitle("Transactions")
        }
        else if (currentEndpoint.includes("/withdraw-requests")) {
            setTitle("Withdrawal Requests")
        }
        else if (currentEndpoint.includes("/reviews")) {
            setTitle("Rating and Reviews")
        }
        else if (currentEndpoint.includes("/admin")) {
            setTitle("Admin")
        }

    }, []);
    // const history = useNavigate();
    // const goBack = () => {
    //     history(-1); // Goes back to the previous route
    // };

    const hideSearch = ["Admin", "Membership Plans", "Subscription Plans", "Subscription Feature Values", "Worker Categories"];
    const hideDateFilter = ["Doorstep Categories", "Requirement Values"];
    const showFilterOption = ["Workers", "Doorstep Orders"];

    return (

        <nav className="navbar navbar-main navbar-expand-lg px-0 mx-md-4 shadow-none border-radius-xl ms-0" id="navbarBlur" data-scroll="true" >
            <div className="container-fluid py-1 d-flex justify-content-between flex-column flex-md-row align-items-start">
                <div className="d-flex">
                    {
                        showAllFilters ?
                            // <button className="d-flex justify-content-center align-items-center back-btn me-2" onClick={() => {
                            //     setIsBackClicked(true);
                            //     goBack()
                            // }}>
                            //     <img src={backIcon} alt="backIcon" />
                            // </button>
                            <BackButton />
                            : ""
                    }

                    <nav aria-label="breadcrumb" >
                        <ol className="breadcrumb bg-transparent mb-0 px-0 me-sm-3 me-3">
                            <li className=" text-sm">
                                <h4 className="font-weight-bolder mb-0 text-start">{`${title}`}</h4>
                            </li>
                        </ol>
                    </nav>

                    <div className='border-0' id="hamburger" onClick={() => dispatch(setMenu(!menuToggle))}>
                        <img src={burgurMenu} alt="menu" style={{ height: "30px", width: "30px" }} />
                    </div>
                </div>

                {
                    hideSearch.includes(title) ? "" : !showAllFilters ?
                        <div className="d-flex justify-content-end gap-3 flex-sm-row sm-container w-md-auto">

                            {
                                hideDateFilter.includes(title) ? "" :
                                    // <DateRangu />
                                    <DateRange startDate={startDate} endDate={endDate} setStartDate={startDateOnChange} setEndDate={endDateOnChange} />
                            }


                            <div className="d-flex justify-content-end w-100  ">
                                <SearchBar searchValue={searchValue} searchOnChange={searchOnChange} clearValChange={clearValChange} />
                            </div>
                        </div> : ''

                }


            </div>

            {/* Core JS Files   */}
            <script src="../assets/js/core/popper.min.js" />
            <script src="../assets/js/core/bootstrap.min.js" />
            <script src="../assets/js/plugins/perfect-scrollbar.min.js" />
            <script src="../assets/js/plugins/smooth-scrollbar.min.js" />
            <script src="../assets/js/plugins/chartjs.min.js" />
            <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900|Roboto+Slab:400,700" />
            {/* <!-- Nucleo Icons --> */}
            <link href="../assets/css/nucleo-icons.css" rel="stylesheet" />
            <link href="../assets/css/nucleo-svg.css" rel="stylesheet" />
            {/* <!-- Font Awesome Icons --> */}
            <script src="https://kit.fontawesome.com/42d5adcbca.js" />
            {/* <!-- Material Icons --> */}
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Round" rel="stylesheet" />
            {/* <!-- CSS Files --> */}
            <link id="pagestyle" href="../assets/css/material-dashboard.css?v=3.1.0" rel="stylesheet" />
        </nav>

    )
}

export default Header;